<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NjBIAJ/tc-custom/9781614236924.jpg?1702065250448" alt="This image is the cover for the book Haunted Scranton, Haunted America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Haunted Scranton, Haunted America
      </h1>
      <p class="bookDescription body article font2">
        <b>A tour of the spookiest spots in this Pennsylvania city, filled with local history and legends . . . Includes photos!</b><br/>  <br/> At the heart of the Lackawanna Valley, Scranton is haunted by those who once walked its streets and worked its mines and rail lines. From the woman in white who lingers in Courthouse Square to the passenger of trolley car #46 who never reached her destination, the specters of Scranton make their presence known.<br/>  <br/> Supernatural investigator A.C. Bernardi chronicles chilling tales of the city’s landmarks, from the mysterious happenings on the sixth floor of the Lackawanna Station Hotel to stories of the angry spirits of victims of the Spanish influenza epidemic who lurk in the basement of the Banshee Pub. Join him as he traverses the dark side of Scranton, Pennsylvania.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        A.C. Bernardi
      </h2>
      
      <p class="authorDescription body article">Through historical research and his own documented experiences during actual paranormal investigations of local haunted sites, A.C. Bernardi developed the script for the popular Scranton after Dark, A Walk through Haunted History"? tour."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Haunted America
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2908528a